// Utils
import { createApolloClient } from '../apollo-node-client';
import { PlansListAllDocument, PlansListAllQuery } from '@gql';

export const imperativeServerPlansListAllQuery = async () => {
  const apolloClient = createApolloClient();
  const response = await apolloClient.query<PlansListAllQuery>({
    ...{
      query: PlansListAllDocument,
    },
  });
  return response;
};
